/* Hero Highlights Continuous Scroll Ticker */

(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 991;
  const SCROLL_SPEED = 1; // pixels per frame (adjust for speed)
  let tickerInstances = [];

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function initTicker(section) {
    const columnsContainer = section.querySelector('.rbsv2-columns__columns');
    if (!columnsContainer) return null;

    // Check if already initialized
    if (columnsContainer.hasAttribute('data-ticker-initialized')) {
      return null;
    }

    // Store original classes
    const originalClasses = columnsContainer.className;
    columnsContainer.setAttribute('data-original-classes', originalClasses);
    columnsContainer.setAttribute('data-ticker-initialized', 'true');

    // Get all columns
    const columns = Array.from(columnsContainer.children).filter(el => 
      el.classList.contains('rbsv2-columns__column')
    );
    
    if (columns.length === 0) {
      columns.push(...Array.from(columnsContainer.querySelectorAll('.rbsv2-columns__column')));
    }
    
    if (columns.length === 0) return null;

    // Create ticker wrapper
    const tickerWrapper = document.createElement('div');
    tickerWrapper.className = 'why-nmn-powder-ticker';
    tickerWrapper.style.cssText = 'width: 100%; overflow: hidden; position: relative;';
    
    // Create inner scroll container
    const scrollContainer = document.createElement('div');
    scrollContainer.className = 'why-nmn-powder-ticker-inner';
    scrollContainer.style.cssText = 'display: flex; will-change: transform; gap: 40px;';
    
    // Store reference to parent
    const parentNode = columnsContainer.parentNode;
    
    // Wrap columns container
    parentNode.insertBefore(tickerWrapper, columnsContainer);
    tickerWrapper.appendChild(scrollContainer);
    scrollContainer.appendChild(columnsContainer);
    
    // Calculate total width first
    function calculateWidths() {
      const containerWidth = tickerWrapper.offsetWidth;
      let totalWidth = 0;
      const spaceBetween = 20;
      
      columns.forEach((column, index) => {
        const width = column.offsetWidth || column.clientWidth;
        totalWidth += width;
        if (index < columns.length - 1) {
          totalWidth += spaceBetween;
        }
      });
      
      return {
        containerWidth: containerWidth,
        contentWidth: totalWidth,
        spaceBetween: spaceBetween
      };
    }

    // Set up styles for columns container
    columnsContainer.style.cssText = 'display: flex; flex-shrink: 0;';
    
    // Add margin-left to first column and gap between columns
    Array.from(columnsContainer.children).forEach((column, index) => {
      if (index === 0) {
        column.style.marginLeft = '45px';
      }
      if (index < columnsContainer.children.length - 1) {
        
      }
    });

    let scrollPosition = 0;
    let isPaused = false;
    let animationFrameId = null;
    let isDestroyed = false;
    let cloneCount = 0;
    const maxClones = 8;
    let widths = calculateWidths();
    let startTime = null;
    const INITIAL_DELAY = 1800; // 1 second delay in milliseconds

    // Function to clone columns container
    function cloneItems() {
      const duplicateContainer = columnsContainer.cloneNode(true);
      duplicateContainer.className = columnsContainer.className + ' ticker-duplicate';
      duplicateContainer.style.cssText = 'display: flex; flex-shrink: 0;';
      
      // Add gap between columns in duplicate
      Array.from(duplicateContainer.children).forEach((column, index) => {
        if (index < duplicateContainer.children.length - 1) {
          column.style.marginRight = '20px';
        }
      });
      
      scrollContainer.appendChild(duplicateContainer);
      cloneCount++;
    }

    // Wait for layout to calculate widths accurately, then start with initial clone
    setTimeout(function() {
      widths = calculateWidths();
      
      // Start with one clone for seamless loop
      cloneItems();
      
      // Initialize animation after initial clone is added
      initAnimation();
    }, 50);

    // Animation function
    function animate() {
      if (isDestroyed) return;
      
      // Initialize start time on first frame
      if (startTime === null) {
        startTime = performance.now();
      }
      
      // Check if initial delay has passed
      const elapsed = performance.now() - startTime;
      const delayPassed = elapsed >= INITIAL_DELAY;
      
      if (!isPaused && delayPassed) {
        scrollPosition -= SCROLL_SPEED;
        scrollContainer.style.transform = `translateX(${scrollPosition}px)`;

        // Dynamically add more clones when the last item is about to go off-screen
        const lastItem = scrollContainer.lastElementChild;
        if (lastItem) {
          const lastItemRect = lastItem.getBoundingClientRect();
          // If last item's right edge is still visible or about to go off-screen, add more clones
          if (lastItemRect.right <= window.innerWidth + 100 && cloneCount < maxClones) {
            cloneItems();
            // Recalculate widths after adding clone (in case content changed)
            widths = calculateWidths();
          }
        }
      }
      
      animationFrameId = requestAnimationFrame(animate);
    }

    // Handle resize
    function handleResize() {
      const newWidths = calculateWidths();
      widths.containerWidth = newWidths.containerWidth;
      widths.contentWidth = newWidths.contentWidth;
    }

    const resizeHandler = handleResize;
    window.addEventListener('resize', resizeHandler);

    // Destroy function
    function destroy() {
      isDestroyed = true;
      if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }
      window.removeEventListener('resize', resizeHandler);
    }

    // Initialize animation function
    function initAnimation() {
      // Recalculate widths after clones are added
      widths = calculateWidths();
      
      // Start animation
      animate();

      // Pause on hover
      tickerWrapper.addEventListener('mouseenter', function() {
        isPaused = true;
      });
      
      tickerWrapper.addEventListener('mouseleave', function() {
        isPaused = false;
      });
    }

    // Store instance
    tickerInstances.push({
      section: section,
      wrapper: tickerWrapper,
      container: scrollContainer,
      columnsContainer: columnsContainer,
      columns: columns,
      pause: function() { isPaused = true; },
      resume: function() { isPaused = false; },
      destroy: destroy
    });

    return tickerWrapper;
  }

  function destroyTicker(instance) {
    if (!instance) return;

    instance.destroy();

    const { wrapper, container, columnsContainer } = instance;
    
    // Restore original structure
    if (wrapper && wrapper.parentNode) {
      const originalClasses = columnsContainer.getAttribute('data-original-classes');
      if (originalClasses) {
        columnsContainer.className = originalClasses;
      }
      
      columnsContainer.removeAttribute('data-ticker-initialized');
      
      // Remove all duplicate containers
      if (container) {
        const duplicates = container.querySelectorAll('.ticker-duplicate');
        duplicates.forEach(dup => dup.remove());
      }
      
      // Move container back to original position
      wrapper.parentNode.insertBefore(columnsContainer, wrapper);
      wrapper.remove();
    }
  }

  function handleResize() {
    const sections = document.querySelectorAll('.why-nmn-powder-columns');
    
    sections.forEach(section => {
      const existingInstance = tickerInstances.find(inst => inst.section === section);
      
      if (isMobile()) {
        // Initialize ticker if not already initialized
        if (!existingInstance) {
          initTicker(section);
        }
      } else {
        // Destroy ticker if it exists
        if (existingInstance) {
          destroyTicker(existingInstance);
          tickerInstances = tickerInstances.filter(inst => inst.section !== section);
        }
      }
    });
  }

  // Initialize on DOM ready
  function init() {
    function setupResizeHandler() {
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 250);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        handleResize();
        setupResizeHandler();
      });
    } else {
      setTimeout(function() {
        handleResize();
        setupResizeHandler();
      }, 0);
    }
  }

  init();
})();



/* not-just-aging SEction - Media Content Duplicate for Mobile */

(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 990;
  const TARGET_SECTION_ID = 'rbsv2-media-content-template--21042289705218__rbsv2_media_content_9NDxMg';
  const ELEMENTS_TO_MOVE = [
    'rbsv2-media-content-title-title_ziJwqn',
    'rbsv2-media-content-title-title_dGBdQG',
    'rbsv2-media-content-description-description_XyVKTr'
  ];

  let originalPositions = new Map();

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function duplicateContentForMobile() {
    if (!isMobile()) {
      // If not mobile, restore elements to original positions
      restoreElements();
      return;
    }

    const targetSection = document.getElementById(TARGET_SECTION_ID);
    if (!targetSection) return;

    // Check if already duplicated
    if (targetSection.querySelector('.rbsv2-media-content__content-duplicate')) {
      return;
    }

    const mediaDiv = targetSection.querySelector('.rbsv2-media-content__media');
    if (!mediaDiv) return;

    // Create duplicate container
    const duplicateContainer = document.createElement('div');
    duplicateContainer.className = 'rbsv2-media-content__content-duplicate';
    duplicateContainer.style.cssText = 'display: flex; flex-direction: column; order: -1;';

    // Find and move elements, storing their original positions
    let elementsMoved = 0;
    ELEMENTS_TO_MOVE.forEach(function(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        // Store original parent and next sibling for restoration
        originalPositions.set(element, {
          parent: element.parentNode,
          nextSibling: element.nextSibling
        });
        
        duplicateContainer.appendChild(element);
        elementsMoved++;
      }
    });

    // Only insert if we found at least one element
    if (elementsMoved > 0) {
      // Insert before media div
      mediaDiv.parentNode.insertBefore(duplicateContainer, mediaDiv);
    }
  }

  function restoreElements() {
    const targetSection = document.getElementById(TARGET_SECTION_ID);
    if (!targetSection) return;

    const duplicateContainer = targetSection.querySelector('.rbsv2-media-content__content-duplicate');
    if (!duplicateContainer) {
      // If no duplicate container, clear positions and return
      originalPositions.clear();
      return;
    }

    // Move elements back to their original positions
    ELEMENTS_TO_MOVE.forEach(function(elementId) {
      const element = document.getElementById(elementId);
      if (element && originalPositions.has(element)) {
        const original = originalPositions.get(element);
        // Only restore if element is currently in duplicate container
        if (element.parentNode === duplicateContainer && original.parent) {
          if (original.nextSibling && original.nextSibling.parentNode === original.parent) {
            original.parent.insertBefore(element, original.nextSibling);
          } else {
            original.parent.appendChild(element);
          }
        }
      }
    });

    // Remove duplicate container
    duplicateContainer.remove();
    originalPositions.clear();
  }

  function handleResize() {
    if (isMobile()) {
      duplicateContentForMobile();
    } else {
      restoreElements();
    }
  }

  // Initialize on DOM ready
  function init() {
    function setupResizeHandler() {
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 250);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        handleResize();
        setupResizeHandler();
      });
    } else {
      setTimeout(function() {
        handleResize();
        setupResizeHandler();
      }, 0);
    }
  }

  init();
})();



/* tried-everything Section - Media Content Duplicate for Mobile */

(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 990;
  const TARGET_SECTION_ID = 'rbsv2-media-content-template--21042289705218__rbsv2_media_content_VPcwPY';
  const ELEMENTS_TO_MOVE = [
    'rbsv2-media-content-description-description_g9kZpH',
    'rbsv2-media-content-description-description_YLjU4U',
    'rbsv2-media-content-description-description_MWRMFX',
    'rbsv2-media-content-description-description_wHfzM8'
  ];

  let originalPositions = new Map();

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function duplicateContentForMobile() {
    if (!isMobile()) {
      // If not mobile, restore elements to original positions
      restoreElements();
      return;
    }

    const targetSection = document.getElementById(TARGET_SECTION_ID);
    if (!targetSection) return;

    // Check if already duplicated
    if (targetSection.querySelector('.rbsv2-media-content__content-duplicate')) {
      return;
    }

    const mediaDiv = targetSection.querySelector('.rbsv2-media-content__media');
    if (!mediaDiv) return;

    // Create duplicate container
    const duplicateContainer = document.createElement('div');
    duplicateContainer.className = 'rbsv2-media-content__content-duplicate';
    duplicateContainer.style.cssText = 'display: flex; flex-direction: column; order: -1;';

    // Find and move elements, storing their original positions
    let elementsMoved = 0;
    ELEMENTS_TO_MOVE.forEach(function(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        // Store original parent and next sibling for restoration
        originalPositions.set(element, {
          parent: element.parentNode,
          nextSibling: element.nextSibling
        });
        
        duplicateContainer.appendChild(element);
        elementsMoved++;
      }
    });

    // Only insert if we found at least one element
    if (elementsMoved > 0) {
      // Insert before media div
      mediaDiv.parentNode.insertBefore(duplicateContainer, mediaDiv);
    }
  }

  function restoreElements() {
    const targetSection = document.getElementById(TARGET_SECTION_ID);
    if (!targetSection) return;

    const duplicateContainer = targetSection.querySelector('.rbsv2-media-content__content-duplicate');
    if (!duplicateContainer) {
      // If no duplicate container, clear positions and return
      originalPositions.clear();
      return;
    }

    // Move elements back to their original positions
    ELEMENTS_TO_MOVE.forEach(function(elementId) {
      const element = document.getElementById(elementId);
      if (element && originalPositions.has(element)) {
        const original = originalPositions.get(element);
        // Only restore if element is currently in duplicate container
        if (element.parentNode === duplicateContainer && original.parent) {
          if (original.nextSibling && original.nextSibling.parentNode === original.parent) {
            original.parent.insertBefore(element, original.nextSibling);
          } else {
            original.parent.appendChild(element);
          }
        }
      }
    });

    // Remove duplicate container
    duplicateContainer.remove();
    originalPositions.clear();
  }

  function handleResize() {
    if (isMobile()) {
      duplicateContentForMobile();
    } else {
      restoreElements();
    }
  }

  // Initialize on DOM ready
  function init() {
    function setupResizeHandler() {
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 250);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        handleResize();
        setupResizeHandler();
      });
    } else {
      setTimeout(function() {
        handleResize();
        setupResizeHandler();
      }, 0);
    }
  }

  init();
})();



/* finally-supplement Section - Media Content Duplicate for Mobile */
  (function() {
    'use strict';

    const MOBILE_BREAKPOINT = 990;
    const TARGET_SECTION_ID = 'rbsv2-columns-template--21042289705218__rbsv2_columns_yWXRja';
    const COLUMNS_CONTAINER_ID = 'rbsv2-columns-columns-template--21042289705218__rbsv2_columns_yWXRja';
    const IMAGE_ELEMENT_ID = 'rbsv2-columns-column-image-column_aLRPgq';
    const CONTENT_ELEMENT_ID = 'rbsv2-columns-column-content-wrapper-column_aLRPgq';

    let originalPositions = new Map();
    let firstDiv = null;
    let lastDiv = null;

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function duplicateContentForMobile() {
      if (!isMobile()) {
        // If not mobile, restore elements to original positions
        restoreElements();
        return;
      }

      const targetSection = document.getElementById(TARGET_SECTION_ID);
      if (!targetSection) return;

      const columnsContainer = document.getElementById(COLUMNS_CONTAINER_ID);
      if (!columnsContainer) return;

      // Check if already duplicated
      if (targetSection.querySelector('.rbsv2-columns__column-duplicated-first') || 
          targetSection.querySelector('.rbsv2-columns__column-duplicated-last')) {
        return;
      }

      const imageElement = document.getElementById(IMAGE_ELEMENT_ID);
      const contentElement = document.getElementById(CONTENT_ELEMENT_ID);

      if (!imageElement || !contentElement) return;

      // Store original positions
      originalPositions.set(imageElement, {
        parent: imageElement.parentNode,
        nextSibling: imageElement.nextSibling
      });
      
      originalPositions.set(contentElement, {
        parent: contentElement.parentNode,
        nextSibling: contentElement.nextSibling
      });

      // Create first div at the beginning
      firstDiv = document.createElement('div');
      firstDiv.className = 'rbsv2-columns__column-duplicated-first';
      columnsContainer.insertBefore(firstDiv, columnsContainer.firstChild);
      firstDiv.appendChild(imageElement);

      // Create last div at the end
      lastDiv = document.createElement('div');
      lastDiv.className = 'rbsv2-columns__column-duplicated-last';
      columnsContainer.appendChild(lastDiv);
      lastDiv.appendChild(contentElement);
    }

    function restoreElements() {
      const imageElement = document.getElementById(IMAGE_ELEMENT_ID);
      const contentElement = document.getElementById(CONTENT_ELEMENT_ID);

      // Restore image element
      if (imageElement && originalPositions.has(imageElement)) {
        const original = originalPositions.get(imageElement);
        if (imageElement.parentNode === firstDiv && original.parent) {
          if (original.nextSibling && original.nextSibling.parentNode === original.parent) {
            original.parent.insertBefore(imageElement, original.nextSibling);
          } else {
            original.parent.appendChild(imageElement);
          }
        }
      }

      // Restore content element
      if (contentElement && originalPositions.has(contentElement)) {
        const original = originalPositions.get(contentElement);
        if (contentElement.parentNode === lastDiv && original.parent) {
          if (original.nextSibling && original.nextSibling.parentNode === original.parent) {
            original.parent.insertBefore(contentElement, original.nextSibling);
          } else {
            original.parent.appendChild(contentElement);
          }
        }
      }

      // Remove duplicate divs
      if (firstDiv && firstDiv.parentNode) {
        firstDiv.remove();
        firstDiv = null;
      }
      
      if (lastDiv && lastDiv.parentNode) {
        lastDiv.remove();
        lastDiv = null;
      }

      originalPositions.clear();
    }

    function handleResize() {
      if (isMobile()) {
        duplicateContentForMobile();
      } else {
        restoreElements();
      }
    }

    // Initialize on DOM ready
    function init() {
      function setupResizeHandler() {
        let resizeTimeout;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(handleResize, 250);
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          handleResize();
          setupResizeHandler();
        });
      } else {
        setTimeout(function() {
          handleResize();
          setupResizeHandler();
        }, 0);
      }
    }

    init();
  })();



/* Featured Product - Duplicate Info for Mobile */

(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 990;
  const TARGET_SECTION_ID = 'FeaturedProduct-template--21042289705218__rbsv3_featured_product_EiQbrN';
  const ELEMENTS_TO_MOVE = [
    'rbsv3-featured-product-star-rating-star_rating_AaTKYR',
    'rbsv2-featured-product-custom-title-custom_title_eaJC9K',
    'rbsv2-featured-product-custom-description-custom_description_rxexqc'
  ];

  let originalPositions = new Map();
  let duplicateContainer = null;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function duplicateContentForMobile() {
    if (!isMobile()) {
      // If not mobile, restore elements to original positions
      restoreElements();
      return;
    }

    const targetSection = document.getElementById(TARGET_SECTION_ID);
    if (!targetSection) return;

    const featuredProduct = targetSection.querySelector('.featured-product');
    if (!featuredProduct) return;

    // Check if already duplicated
    if (featuredProduct.querySelector('.product__info-wrapper-duplicated')) {
      return;
    }

    // Create duplicate container
    duplicateContainer = document.createElement('div');
    duplicateContainer.className = 'product__info-wrapper-duplicated';

    // Find and move elements, storing their original positions
    let elementsMoved = 0;
    ELEMENTS_TO_MOVE.forEach(function(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        // Store original parent and next sibling for restoration
        originalPositions.set(element, {
          parent: element.parentNode,
          nextSibling: element.nextSibling
        });
        
        duplicateContainer.appendChild(element);
        elementsMoved++;
      }
    });

    // Only insert if we found at least one element
    if (elementsMoved > 0) {
      // Insert at the beginning of featured-product
      featuredProduct.insertBefore(duplicateContainer, featuredProduct.firstChild);
    }
  }

  function restoreElements() {
    const targetSection = document.getElementById(TARGET_SECTION_ID);
    if (!targetSection) return;

    const featuredProduct = targetSection.querySelector('.featured-product');
    if (!featuredProduct) return;

    duplicateContainer = featuredProduct.querySelector('.product__info-wrapper-duplicated');
    if (!duplicateContainer) {
      // If no duplicate container, clear positions and return
      originalPositions.clear();
      return;
    }

    // Move elements back to their original positions
    ELEMENTS_TO_MOVE.forEach(function(elementId) {
      const element = document.getElementById(elementId);
      if (element && originalPositions.has(element)) {
        const original = originalPositions.get(element);
        // Only restore if element is currently in duplicate container
        if (element.parentNode === duplicateContainer && original.parent) {
          if (original.nextSibling && original.nextSibling.parentNode === original.parent) {
            original.parent.insertBefore(element, original.nextSibling);
          } else {
            original.parent.appendChild(element);
          }
        }
      }
    });

    // Remove duplicate container
    duplicateContainer.remove();
    duplicateContainer = null;
    originalPositions.clear();
  }

  function handleResize() {
    if (isMobile()) {
      duplicateContentForMobile();
    } else {
      restoreElements();
    }
  }

  // Initialize on DOM ready
  function init() {
    function setupResizeHandler() {
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 250);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        handleResize();
        setupResizeHandler();
      });
    } else {
      setTimeout(function() {
        handleResize();
        setupResizeHandler();
      }, 0);
    }
  }

  init();
})();

/* Review Carousel Continuous Loop for Desktop */

(function() {
  const MOBILE_BREAKPOINT = 991;
  const originalParentAttribute = 'data-original-parent';
  const clonedParentAttribute = 'data-cloned-parent';
  const clonedWrapperClass = 'review-carousel-wrapper-clone';
  let tries = 0;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function duplicateReviewContent(swiperContainer) {
    if (tries > 5) {
      return null;
    }

    tries++;
    if (swiperContainer.offsetWidth <= window.innerWidth + 100) {
      const firstSwiperItem = swiperContainer.querySelector('.swiper-slide.swiper-slide-active');
      if (!firstSwiperItem || !firstSwiperItem.style.width) {
        setTimeout(function() {
          duplicateReviewContent(swiperContainer);
        }, 500);
      } else {
        cloneContent(swiperContainer);
      }
    }
  }

  function cloneContent(swiperContainer) {
    const parentCopy = cloneParent(swiperContainer);
    hideOriginalParent();
    cloneSliderContent(parentCopy);
  }

  function hideOriginalParent() {
    const originalParent = document.querySelector('[' + 'data-original-parent' + ']');
    if (originalParent) {
      originalParent.style.display = 'none';
    }
  }

  function cloneParent(swiperContainer) {
    const currentParent = swiperContainer.parentNode;
    currentParent.setAttribute(originalParentAttribute, true);
    const parentCopy = currentParent.cloneNode(true);
    parentCopy.setAttribute(clonedParentAttribute, true);
    currentParent.parentNode.appendChild(parentCopy);

    return parentCopy;
  }

  function cloneSliderContent(parentCopy) {
    const swiperContainer = parentCopy.querySelector('.swiper-wrapper');
    const swiperContainerCopy = swiperContainer.cloneNode(true);
  
    const newParent = document.createElement('div');
    newParent.style.cssText = 'display: flex; animation: slide-left 30s linear infinite;';
    newParent.className = clonedWrapperClass;
    parentCopy.replaceChild(newParent, swiperContainer);

    newParent.appendChild(swiperContainer);
    newParent.appendChild(swiperContainerCopy);
  }

  function restoreDefaultWrapper(swiperContainer, clonedWrapper) {
    const clonedParent = document.querySelector('[' + clonedParentAttribute + ']');
    clonedParent.remove();
    const originalParent = document.querySelector('[' + originalParentAttribute + ']');
    originalParent.style.display = 'flex';
  }

  function updateWidths() {
    const sectionWrapper = document.querySelector('.rbsv3-reviews-carousel__inner');
    if (!sectionWrapper) {
      return;
    }

    const newWidth = sectionWrapper.clientWidth / 4;
    const clonedSliderContent = document.querySelectorAll('[' + clonedParentAttribute + ']' + ' .swiper-slide');
    [...clonedSliderContent].forEach((content) => {
      content.style.width = newWidth.toString() + 'px';
    });
  }

  function handleResize() {
    const sectionContainer = document.querySelector('.faq-carousel');
    if (!sectionContainer) {
      return null;
    }

    const swiperContainer = sectionContainer.querySelector(':not(.rbsv3-reviews-carousel__preview-mobile) > .swiper-wrapper');
    if (!swiperContainer) {
      return null;
    }
    
    if (isMobile()) {
      // Restore default wrapper if cloned wrapper exists
      const clonedWrapper = document.querySelector('.' + clonedWrapperClass);
      if (clonedWrapper) {
        restoreDefaultWrapper(swiperContainer, clonedWrapper);
      }
    } else {
      // Initialize cloned wrapper if not already initialized
      const clonedWrapper = document.querySelector('.' + clonedWrapperClass);
      if (!clonedWrapper) {
        tries = 0;
        duplicateReviewContent(swiperContainer);
      } else {
        updateWidths();
      }
    };
  }

    // Initialize on DOM ready
  function init() {
    function setupResizeHandler() {
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 250);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        handleResize();
        setupResizeHandler();
      });
    } else {
      setTimeout(function() {
        handleResize();
        setupResizeHandler();
      }, 0);
    }
  }

  init();
})();